/* eslint-disable no-const-assign */
<template>
  <div class="wrapper .ccui-navigation">
    <base-bread-crumb :currBreadCrumb="currBreadCrumb"></base-bread-crumb>
    <div class="ccui-app-container">
      <div class="ccui-app-container-detail-body content">
        <div class="page-title">{{ $t("page.retrievePassword.title") }}</div>
        <el-divider></el-divider>
        <el-form :model="fromData" :rules="rules" ref="ruleForm" :validate-on-rule-change="false" class="ccui-form">
          <el-form-item label-width="350px" :label="$t('page.retrievePassword.supName')" prop="supName">
            <el-col :span="14">
              <el-input v-model="fromData.supName" :placeholder="$t('page.retrievePassword.holderSupName')"
                @blur="supNameCheckBlur"></el-input>
            </el-col>
          </el-form-item>
          <!-- <el-form-item label-width="350px" :label="$t('page.retrievePassword.contactPerson')" prop="contactName"
            class="item-err2">
            <el-col :span="14">
              <el-input v-model="fromData.contactName"
                :placeholder="$t('page.retrievePassword.holderContactPerson')"></el-input>
            </el-col>
          </el-form-item> -->
          <el-form-item label-width="350px" :label="$t('page.retrievePassword.Authentication')" prop="authentication">
            <el-radio-group v-model="Authentication" @change="changeAuthentication">
              <el-radio :label="0" value="0">{{
                $t("page.retrievePassword.mobilePhone")
              }}</el-radio>
              <el-radio :label="1" value="1">{{
                $t("page.retrievePassword.email")
              }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label-width="350px" v-if="Authentication == 0"
            :label="$t('page.retrievePassword.contactsMobile')" prop="contactMobile">
            <el-col :span="14">
              <el-input @input="onMobileInput" :placeholder="$t('page.retrievePassword.contactsMobileMsg')"
                v-model="fromData.contactMobile" show-word-limit :maxlength="15"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label-width="350px" :label="$t('page.retrievePassword.authCode')" prop="contactCode"
            class="authCode" v-if="Authentication == 0">
            <el-col :span="14" style="margin-right: 20px;">
              <!--  验证码  -->
              <el-input :placeholder="$t('page.retrievePassword.authCodeMsg')" v-model="fromData.contactCode"
                autocomplete="noneoff"></el-input>
            </el-col>
            <el-button type="primary" :disabled="codeDisabled || getCodeLoading" @click="getCode('iphone')" class="codeBtn" v-show="show"
              :class="{ enBtn: true }" :loading="getCodeLoading">{{ $t("page.retrievePassword.getCode") }}</el-button>
            <el-button type="primary" @click="getCode" class="count" v-show="!show" :disabled="timeDisabled">{{ count
            }}</el-button>

          </el-form-item>
          <el-form-item label-width="350px" v-if="Authentication == 1"
            :label="$t('page.retrievePassword.contactsEmail')" prop="contactEmail">
            <el-col :span="14">
              <!--  联系人E-mail  -->
              <el-input @input="onEmailInput" :placeholder="$t('page.retrievePassword.contactsEmailMsg')"
                v-model="fromData.contactEmail" maxlength="320"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label-width="350px" :label="$t('page.retrievePassword.authCode')" prop="contactCode"
            class="authCode" v-if="Authentication == 1">
            <el-col :span="14" style="margin-right: 20px;">
              <!--  验证码  -->
              <el-input :placeholder="$t('page.retrievePassword.authCodeMsg')" v-model="fromData.contactCode"
                autocomplete="noneoff"></el-input>
            </el-col>
            <el-button type="primary" :disabled="codeDisabled || getCodeLoading" @click="getCode('Email')" class="codeBtn" v-show="show"
              :class="{ enBtn: true }" :loading="getCodeLoading">{{ $t("page.retrievePassword.getCode") }}</el-button>
            <el-button type="primary" @click="getCode" class="count" v-show="!show" :disabled="timeDisabled">{{ count
            }}</el-button>
          </el-form-item>
          <!-- 222 -->
          <!-- <el-form-item label-width="350px" :label="$t('page.retrievePassword.mobilePhone')" prop="contactMobile"
            class="item-err3">
            <el-col :span="14">
              <el-input v-model="fromData.contactMobile"
                :placeholder="$t('page.retrievePassword.holderMobilePhone')"></el-input>
            </el-col>
          </el-form-item> -->
          <el-form-item :label="$t('page.retrievePassword.newPassword')" label-width="350px" prop="password"
            ref="passwordRef">
            <el-col :span="14">
              <!--  密码  -->
              <el-input show-password :placeholder="$t('page.retrievePassword.pleaseNewPassword')"
                v-model="fromData.password" autocomplete="new-password"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item :label="$t('page.retrievePassword.confirmPassword')" label-width="350px" prop="rePassword">
            <el-col :span="14">
              <!--  重复输入密码  -->
              <el-input show-password :placeholder="$t('page.retrievePassword.pleaseConfirmPassword')"
                v-model="fromData.rePassword" autocomplete="new-password"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item size="large" style="text-align:center;margin-top:20px;">
            <el-button type="primary" @click="onSubmit('ruleForm')">{{
              $t("page.retrievePassword.submit")
            }}</el-button>
            <el-button class="btn1" @click="resetForm('ruleForm')">{{
              $t("page.retrievePassword.reset")
            }}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable */
import Cookies from "js-cookie";
import baseBreadCrumb from "@/app/shop/components/baseBreadCrumb";
import { supSendMessage, supResetPassword, checkSuppilerName } from '../api/shopping'

export default {
  name: "retrievePassword",
  components: {
    baseBreadCrumb
  },
  data() {
    const checkCode = (rule, value, callback) => {
      if (value != this.codeStr) {
        callback(new Error(this.$t('page.retrievePassword.effectiveVerificationCode')));
      } else {
        callback();
      }
    };
    return {
      language: 'en-gb',
      currBreadCrumb: [
        {
          title: this.$t("page.retrievePassword.retrievePassword")
        }
      ],
      show: true,
      codeDisabled: false,
      getCodeLoading: false,
      timeDisabled: true,
      timer: null,
      count: '',
      codeStr: "", // 验证码字符串
      userInput: "", // 用户输入的验证码
      supNameCheckDate: false,
      uploadDisabled: true,
      fromData: {
        supName: "",
        supUserName: "",
        contactName: "",
        contactMobile: "",
        contactEmail: "",
        contactCode: "",
        password: "",
        rePassword: "",
      },
      Authentication: 0,
      index: "",
      code: "",
      uploadData: {},
      uploadForm: {
        action: this.$addUrlPerFix(
          process.env.VUE_APP_BASE_URL +
          "/apis/hwsp/smc/users/signup/uploadFileToOssAndSave"
        ),
        headers: {
          Authorization: Cookies.get("access_token") || ""
        }
      },
      baseUrl: this.$addUrlPerFix(process.env.VUE_APP_BASE_URL),
      rules: {
        supName: [
          {
            required: true,
            max: 100,
            message: this.$t("page.retrievePassword.holderSupName"),
            trigger: "blur"
          },
          {
            validator: (rule, value, callback) => {
              setTimeout(() => {
                this.isShow1 = false
                checkSuppilerName({
                  supplierName: this.fromData.supName
                }).then((res) => {
                  console.log(res, '111')
                  if (res.data.data.hasFlag == 0) {
                    callback(new Error(this.$t('page.retrievePassword.confirmTitle4'))) // 该供应商名称已存在
                  } else {
                    callback()
                  }
                }).catch(error => {
                  callback(new Error(this.$t('page.retrievePassword.confirmTitle4')))
                });
              }, 100)
            }, trigger: 'blur'
          }

        ],
        contactMobile: [
          {
            required: true,
            message: this.$t("page.retrievePassword.holderMobilePhone"),
            trigger: "blur"
          },
          // {
          //   pattern: /\-/,
          //   message: this.$t('page.retrievePassword.contactsMobileMsg'),
          //   trigger: 'blur'
          // },


        ],
        contactName: [
          {
            required: true,
            message: this.$t("page.retrievePassword.holderContactPerson"),
            trigger: "blur"
          }
        ],
        contactEmail: [
          {
            required: true,
            message: this.$t("page.retrievePassword.holderEmail"),
            trigger: "blur"
          },
          { pattern: /\@/, message: window.$t('page.retrievePassword.effectiveEmail'), trigger: 'blur' },
          {
            pattern: /^[^\u4e00-\u9fa5]+$/,
            message: window.$t('page.retrievePassword.effectiveEmail'),
            trigger: "blur"
          }
          // {
          //   max: 100,
          //   pattern: /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/,
          //   message: this.$t("page.retrievePassword.effectiveEmail"),
          //   trigger: "blur"
          // }
        ],
        contactCode: [
          {
            required: true,
            message: this.$t("page.retrievePassword.holderVerificationCode"),
            trigger: "blur"
          },
          // {
          //   max: 4,
          //   required: true,
          //   validator: checkCode,
          //   message: this.$t('page.retrievePassword.effectiveVerificationCode'),
          //   trigger: "blur"
          // }
        ],
        password: [{ required: true, message: window.$t('page.applyUsername.inputPlc.pwdMsg'), trigger: 'blur' },
        { min: 8, max: 16, message: window.$t('page.applyUsername.inputRules.pwdMsg1') },
        {
          pattern: /(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])(?=.*[^a-zA-Z0-9]).{8,16}/,
          message: window.$t('page.applyUsername.inputRules.pwdMsg2'), trigger: 'blur'
        }],

        rePassword: [{ required: true, message: window.$t('page.applyUsername.inputPlc.repwdMsg'), trigger: 'blur' },
        {
          validator: (rule, value, callback) => {
            if (value === '') {
              callback(new Error(window.$t('page.retrievePassword.pleasePw')))
            } else if (value !== this.fromData.password) {
              callback(new Error(window.$t('page.applyUsername.inputRules.repwdMsg')))
            } else {
              callback()
            }
          }, message: window.$t('page.applyUsername.inputRules.repwdMsg'), trigger: 'blur'
        }],
      },
      fileData: [
        {
          billType: "906",
          fileinfoTypeName: this.$t("page.retrievePassword.fileinfoType1"),
          fileinfoType: "9061",
          fileType: this.$t("page.retrievePassword.fileTypeName"),
          fileName: "",
          fileSize: "",
          fileUrl: "",
          uploadTime: "",
          uploadId: "",
          isShowDownload: true
        },
        {
          billType: "906",
          fileinfoTypeName: this.$t("page.retrievePassword.fileinfoType2"),
          fileinfoType: "9062",
          fileType: this.$t("page.retrievePassword.fileTypeName"),
          fileName: "",
          fileSize: "",
          fileUrl: "",
          uploadTime: "",
          uploadId: ""
        }
      ]
    };
  },
  watch: {
    // supNameCheckDate(valNew) {
    //   console.log(valNew);
    //   if (valNew === true) {
    //     checkSuppilerName({
    //       supplierName: this.fromData.supName
    //     })
    //       .then(res => {
    //         // debugger;
    //         if (this.fromData.supName != "") {
    //           this.code = true;
    //           // this.uploadData = {
    //           //   loginId: res.data.data.loginId,
    //           //   mobile: res.data.data.mobile,
    //           //   openId: res.data.data.openId,
    //           //   userId: res.data.data.userId
    //           // };
    //         } else {
    //           this.code = false;
    //           this.uploadDisabled = true;
    //           this.$message({
    //             message: res.data.message,
    //             type: "error",
    //             duration: 3000,
    //             showClose: true,
    //             ccuiCustom: true
    //           });
    //           this.fromData.supName = "";
    //         }
    //       })
    //       .catch(err => { });
    //     this.$set(this, "supNameCheckDate", false);
    //   }
    // }
  },
  activated() {

    this.fromData.supName = "";
    this.fromData.contactName = "";
    this.fromData.contactMobile = "";
    this.fromData.contactEmail = "";
    this.fromData.contactCode = "";
    this.fileData.forEach(item => {
      item.fileName = "";
      item.fileSize = "";
      item.fileUrl = "";
      item.uploadTime = "";
      item.uploadId = "";
    });
    this.createCode();
  },
  deactivated() { },
  methods: {
    createCode() {
      const that = this;
      let codeLength = 4; // 验证码长度
      let canvas = this.$refs.canvas;
      let ctx = canvas.getContext("2d");
      let codeChars = "0123456789";
      let code = "";
      for (let i = 0; i < codeLength; i++) {
        let charIndex = Math.floor(Math.random() * codeChars.length);
        code += codeChars.charAt(charIndex);
      }
      this.codeStr = code;

      // 绘制验证码图片
      ctx.fillStyle = that.MathColor(180, 230);
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      ctx.font = that.MathNumber(30, 40) + "px Arial";
      ctx.fillStyle = that.MathColor(80, 180);
      ctx.fillText(code, 20, 45);
      for (var i = 0; i < 6; i++) {
        ctx.strokeStyle = that.MathColor(0, 255);
        ctx.beginPath();
        ctx.moveTo(
          that.MathNumber(0, canvas.width),
          that.MathNumber(0, canvas.height)
        );
        ctx.lineTo(
          that.MathNumber(0, canvas.width),
          that.MathNumber(0, canvas.height)
        );
        ctx.stroke();
      }
      for (var y = 0; y < 50; y++) {
        // ctx.fillStyle = that.MathColor(0, 255);
        ctx.beginPath();
        ctx.arc(
          that.MathNumber(0, canvas.width),
          that.MathNumber(0, canvas.height),
          0.5,
          0,
          2 * Math.PI
        );
        ctx.fill();
      }
    },
    getCode() {
      if (this.getCodeLoading) return
      this.getCodeLoading = true
      supSendMessage({
        supName: this.fromData.supName,
        isCode: this.Authentication == 0 ? 0 : 1,
        mobileOrEmail: this.Authentication == 0 ? this.fromData.contactMobile : this.fromData.contactEmail,
        languageType: 'en-gb',
        languageFlag: "en",
      }).then(res => {
        if (res.data.code === '0') {
          this.fromData.supUserName = res.data.data
          this.$message.success('The SMS verification code has been sent successfully, please pay attention to receiving it')
          const TIME_COUNT = 180;
          if (!this.timer) {
            this.count = TIME_COUNT;
            this.show = false;
            this.timer = setInterval(() => {
              if (this.count > 0 && this.count <= TIME_COUNT) {
                this.count--;
              } else {
                this.show = true;
                clearInterval(this.timer);
                this.timer = null;
              }
            }, 1000)
          }
        }
      }).finally(() => {
        this.getCodeLoading = false
      })

    },
    changeAuthentication(val) {

      this.fromData.contactMobile = ''
      this.fromData.contactEmail = ''
      this.fromData.contactCode = ''
      this.$nextTick(() => {
        this.$refs['ruleForm'].clearValidate(['contactCode']);
        if (val == 0) {
          this.$refs['ruleForm'].clearValidate(['contactMobile']);
        } else {

          this.$refs['ruleForm'].clearValidate(['contactEmail']);

        }
      })
      this.Authentication = val
    },
    onMobileInput() {
      if (this.fromData.contactMobile) {
        this.codeDisabled = false
      } else {
        this.codeDisabled = true
      }
    },
    onEmailInput() {
      if (this.fromData.contactEmail) {
        this.codeDisabled = false
      } else {
        this.codeDisabled = true
      }
    },
    //随机整数
    MathNumber(min, max) {
      var n = Math.floor(Math.random() * (max - min) + min);
      return n;
    },
    //随机颜色
    MathColor(min, max) {
      var r = this.MathNumber(min, max);
      var g = this.MathNumber(min, max);
      var b = this.MathNumber(min, max);
      return `rgb(${r},${g},${b})`;
    },
    isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
    supNameCheckBlur() {
      if (this.fromData.supName) {
        // this.$set(this, "supNameCheckDate", true);
      }
    },
    onSubmit(formName) {
      this.$refs[formName].validate(valid => {
        if (!valid) return
        supResetPassword({
          supUserName: this.fromData.supUserName,
          supPassword: this.fromData.password,
          mobileOrEmail: this.Authentication == 0 ? this.fromData.contactMobile : this.fromData.contactEmail,
          languageFlag: "en",
          isCode: this.Authentication == 0 ? 0 : 1,
          verificationCode: this.fromData.contactCode
        }).then(res => {

          console.log(res, 'resresresres');
          let url = '', path = window.location.href;
          if (path.indexOf("uat01") != -1) {
            url = 'https://uat01-' + process.env.VUE_APP_BASE_URL
          } else if (path.indexOf("test01") != -1) {
            url = 'https://test01-' + process.env.VUE_APP_BASE_URL
          } else if (path.indexOf("dev01") != -1) {
            url = 'https://dev01-' + process.env.VUE_APP_BASE_URL
          } else {
            url = 'https://' + process.env.VUE_APP_BASE_URL
          }
          // window.location.href = 'https://'+process.env.VUE_APP_SUPPLIER_GATEWAY
          window.location.href = url

        })

      });
    },
    resetForm(from) {
      this.$refs[from].resetFields();
    },
    uploadSuccess(res, file, fileList) {
      this.$message.success(this.$t("page.retrievePassword.fileSuccess"));
      this.uploadLoading = false;
      let fileData = res.data[0];
      console.log(fileData);
      let indexs = this.index;
      console.log(indexs);
      this.fileData.forEach((item, i, arr) => {
        arr[indexs].fileUrl = fileData.downloadUrl;
        arr[indexs].fileName = fileData.fileName;
        arr[indexs].fileSize = fileData.fileSize;
        arr[indexs].createTime = fileData.createTime;
        arr[indexs].fileIinfoType = fileData.fileType;
        arr[indexs].uploadId = fileData.uploadId;
      });
      console.log(this.fileData);
    },
    uploadError(err, file, fileList) {
      this.$message({
        message: this.$t("page.retrievePassword.uploadError"),
        type: "error",
        duration: 3000,
        showClose: true,
        ccuiCustom: true
      });
      this.uploadLoading = false;
    },
    onProgress(event, file, fileList) {
      this.uploadLoading = true;
    },
    onUploadData(index, row) {
      this.index = index;
      console.log(this.code);
      this.$refs["ruleForm"].validate(valid => {
        if (valid && this.code == true) {
          this.uploadDisabled = false;
        } else {
          this.uploadDisabled = true;
        }
      });
      if (this.uploadDisabled === true && this.code == false) {
        if (this.fromData.supName === "") {
          this.$confirm(
            this.$t("page.retrievePassword.confirmTitle3"),
            this.$t("page.retrievePassword.confirmHint"),
            {
              confirmButtonText: this.$t("page.retrievePassword.ascertain"),
              showCancelButton: false,
              type: "error"
            }
          );
        } else {
          this.$message({
            message: this.$t("page.retrievePassword.confirmTitle5"),
            type: "warning",
            duration: 3000,
            showClose: true,
            ccuiCustom: true
          });
        }
      }
    },
    deleteRow(index, row) {
      row.fileName = "";
      row.fileSize = "";
      row.fileUrl = "";
      row.uploadTime = "";
      row.uploadId = "";
    },
    beforeAvatarUpload(file) {
      console.log(file);
      let isUpload = true;
      this.uploadLoading = true;
      const isLt50 = file.size < 52428800;
      var testmsg = file.name.substring(file.name.lastIndexOf(".") + 1);
      const extension =
        testmsg === "jpg" ||
        testmsg === "png" ||
        testmsg === "JPG" ||
        testmsg === "PNG" ||
        testmsg === "jpeg" ||
        testmsg === "jpe" ||
        testmsg === "jfif" ||
        testmsg === "JFIF";
      this.fileData.forEach(item => {
        if (item.fileName === file.name) {
          isUpload = false;
          return this.$message.error(
            this.$t("page.retrievePassword.NoSameName")
          );
        }
      });
      if (!isLt50) {
        this.uploadLoading = false;
        this.$message({
          message: this.$t("page.retrievePassword.fileSizeNO50"),
          type: "error",
          duration: 3000,
          showClose: true,
          ccuiCustom: true
        });
        isUpload = false;
        // this.$showErrorMessage("文件大小不可超过50M！");
      }
      if (!extension) {
        this.uploadLoading = false;
        this.$message({
          message: this.$t("page.retrievePassword.uploadBmpError"),
          type: "error",
          duration: 3000,
          showClose: true,
          ccuiCustom: true
        });
        isUpload = false;
        // this.$showErrorMessage("上传文件格式错误！");
      }
      return isLt50 && extension && isUpload;
    },
    download(uploadId, fileName) {
      if (this.baseUrl === "http://dev01-sp.iccec.cn") {
        uploadId = "10005451492";
      } else if (this.baseUrl === "http://test01-sp.iccec.cn") {
        uploadId = "10001013055";
      } else if (this.baseUrl === "http://uat01-sp.iccec.cn") {
        uploadId = "10005117155";
      }
      let openUrl = document.createElement("a");
      openUrl.style.display = "none";
      console.log(uploadId);
      // let zhUrl =
      //   "https://cccc-prod.obs.cn-north-4.myhuaweicloud.com/cccc_home/100116/100001/default/202404/applytables.doc";
      let enUrl =
        "https://cccc-prod.obs.cn-north-4.myhuaweicloud.com/cccc_home/100116/100001/default/202404/Forgot%20your%20username%20or%20password.doc";
      // openUrl.href = `${addUrlPerFix(
      //   process.env.VUE_APP_BASE_URL
      // )}/apis/hwsp/oss/downloadByUploadId?uploadId=${uploadId}`;
      openUrl.href = enUrl;
      openUrl.setAttribute("download", fileName);
      document.body.appendChild(openUrl);
      openUrl.click();
    }
  }
};
</script>

<style scoped lang="scss">
.ver-code {
  position: relative;
}

.caCode {
  position: absolute;
  top: -10px;
  left: 105%;
  display: flex;
  height: 51px;
  // border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  color: #333;
  margin-bottom: 22px;

  el-input {
    width: 60%;
  }
}

/deep/ .el-form-item__label {
  width: 200px;
}

// .item-err2  {
//   /deep/ .el-form-item__error {
//   left: 65px;
// }
// }
// .item-err3  {
//   /deep/ .el-form-item__error {
//   left: 65px;
// }
// }
// .item-err4  {
//   /deep/ .el-form-item__error {
//   left: 65px;
// }
// }
/deep/ .el-divider {
  background-color: transparent !important;
}

/deep/ .el-divider--horizontal {
  display: block;
  height: 1px;
  width: 100%;
  margin: 24px 0;
  border-top: 1px dashed #ccc !important;
}

/deep/ .ccui-ml-10 {
  position: absolute;
  color: #ff142f;
}

/deep/.el-radio__input.is-checked .el-radio__inner {
  background: #FF142F;
  border-color: #ff142f;
}

/deep/.el-radio__inner:hover {
  border-color: #ff142f;
}

/deep/.el-cascader .el-input .el-input__inner:focus,
.el-cascader .el-input.is-focus .el-input__inner {
  border-color: #FF142F;
}

/deep/.el-input__inner:focus {
  border-color: #FF142F;
}

/deep/.el-button--primary {
  background: rgba(255, 20, 47, 1);
}

/deep/.el-button--primary:focus {
  background: rgba(255, 20, 47, 1) !important;
}

.btn:hover {
  border-color: #ff142f;
  background: rgba(255, 20, 47, 1);
}

.el-button.el-button--primary-icon-medium.is-active,
.el-button.el-button--primary-icon-medium:active,
.el-button.el-button--primary-icon-medium:focus,
.el-button.el-button--primary-icon-medium:hover {
  border-color: #ff142f;
  background: rgba(255, 20, 47, 1);
}

.btn1:focus,
.btn1:hover {
  border-color: #ff142f;
  background-color: #fde6e8;
}

.wrapper {
  margin-bottom: 20px;
}

.ccui-app-container-detail {
  min-height: calc(100vh - 190px);
  margin: 0px auto 0px !important;
  padding: 15px 0 15px;
  min-width: 1180px;
}

// /deep/ .el-form-item__error {
//   left: 205px;
// }

.red {
  color: #ff142f;
}

.tdu {
  background: transparent;
  border: 0;
  cursor: pointer;
  outline: none;
}

.mb20 {
  margin-bottom: 20px;
}

.uploadTabInlie {
  display: inline-block;
  margin-right: 10px;
}

/deep/ .el-table--border td:first-child .cell::after {
  content: "*";
  color: #ff142f;
}
</style>
